import React, { useState } from "react";
import { Table, Button, Popconfirm, Avatar, Tag, Modal, Form, Select, Row, Col, message } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { linkPath } from "../../share/helper";
import { request } from "../../share/request";
import { use } from "react";
import { useEffect } from "react";

 
const UserWebSystem = ({ data = [], loading ,onRefresh , onDelete,idorg }) => {
  // 1. State for controlling the visibility of the Add/Edit Modal
  const [isModalVisible, setIsModalVisible] = useState(false);
  // State to hold the data of the user being edited (or null for adding)
  const [editingUser, setEditingUser] = useState(null);
  const [paramFilter, setParamFilter] = useState({
    org_code: idorg,
    txtSearch: "",
  });
  const [btnLoading, setBtnLoading] = useState(false);

  const [userList, setUserList] = useState([]);
  const showModal = (user) => {

    
    setEditingUser(user);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingUser(null);
  };

const handleOk = async (values) => {
  try {
      setBtnLoading(true);
  const data = {
      user_id: values.id,        // from Select user
      system_login: 1,            // or 1 (your choice)
      org_code: idorg,                // your org code
      modified_by:'System', // your logged-in username
    };

    const res = await request("settingcreateuserloginwebsysteminfo", "post", data);

    if (res && res.success===true) {
      message.success("User added successfully!");

      // Close modal
      setIsModalVisible(false);
      setEditingUser(null);
       // 🔥 Trigger parent refresh
      if (onRefresh) {
        onRefresh();
      }
    } else if (res && res.success===false) {
      message.error(res.message );
    }
  } catch (err) {
    console.error("Error:", err);
    message.error("Server error!");
  }finally{
    setBtnLoading(false);
  }
};


  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,
    },
    {
      title: "Full Name",
      dataIndex: "fullname",
      key: "fullname",
      width: 250, 
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Avatar
            size={60}
            src={linkPath+ record.image}
            style={{ border: "2px solid #e0e0e0" }}
          />
          <div>
            <div style={{ fontSize: 16, fontWeight: 600, color: "#333" }}>
              {record.fullname}
            </div>
            <div style={{ fontSize: 14, color: "#888" }}>{record.position_kh}</div>
          </div>
        </div>
      )
    },
    
    {
      title: "Permission",
      dataIndex: "role_name",
      key: "role_name",
      render: (permission) => {
        const color =
          permission === "Admin"
            ? "red"
            : permission === "Manager"
            ? "blue"
            : "green";

        return <Tag color={color}>{permission}</Tag>;
      },
    },
    {
      title: "Department",
      dataIndex: "department_name",
      key: "department_name",
    },
    
    {
      title: "Action",
      key: "action",
      width: 180, // Increased width to fit two buttons
      render: (_, record) => (
        <Row gutter={[8, 0]}>
        
          
          {/* Delete Button */}
          <Col>
            <Popconfirm
              title="Delete user"
              description="Are you sure you want to delete this user?"
              onConfirm={() => onDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button danger icon={<DeleteOutlined />}/> 
            </Popconfirm>
          </Col>
        </Row>
      ),
    },
  ];
const fetchUserLoginInfo = async (paramFilter) => {
  try {
    // Use `textsearch` as backend expects
    const param = new URLSearchParams({
      org_code: idorg,
      textsearch: paramFilter.txtSearch, 
    });

    const res = await request("settinguserloginwebsysteminfo?" + param, "get", {});

    if (res && res.api_userwebloginInfo) {
      setUserList(res.api_userwebloginInfo);
    
    }
  } catch (err) {
    console.error("Error fetching data:", err);
  }
};


useEffect(() => {
 if(idorg){
  fetchUserLoginInfo(paramFilter);
 }
}, [idorg]);
  
const handleSearch = (input) => {
 const newParamFilter = { ...paramFilter, txtSearch: input  };
 setParamFilter(newParamFilter);
  fetchUserLoginInfo(newParamFilter);
}


  return (
    <>
      {/* 💡 MODIFICATION 2: General 'Add New User' button above the table */}
      <div style={{ marginBottom: 16, textAlign: 'right' }}>
        <Button 
          type="primary" 
          icon={<PlusOutlined />} 
          onClick={() => showModal(null)} // Pass null to indicate adding a new user
        >
          Add
        </Button>
      </div>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{ pageSize: 10 }}
      />
      
      {/* 💡 MODIFICATION 3: Modal component */}
      <Modal
        title={editingUser ? `Edit User: ${editingUser.fullname}` : "Add New User"}
        open={isModalVisible}
        onCancel={handleCancel}
        // Removed default OK/Cancel buttons to use the ones inside the Form
        footer={null} 
      >
        <Form
          // Set initial values if editing an existing user
          initialValues={editingUser  }
          onFinish={handleOk}
          layout="vertical"
        >
        
   <Form.Item
  name="id"
  label="Select User"
  rules={[{ required: true, message: "Please select a user!" }]}
>
   <Select
  placeholder="Select a User"
  showSearch
  allowClear
  style={{ height: 80 }}
  onSearch={(input) => handleSearch(input)} // server-side search trigger
  filterOption={false} // disable client-side filtering
  notFoundContent="No users found"
>
  {userList.map((user) => (
    <Select.Option key={user.id} value={user.id}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Avatar size={32} src={user.image ? linkPath + user.image : null} />
        <div>
          <div style={{ fontWeight: 500 }}>{user.fullname}</div>
          <div style={{ fontSize: 12, color: "#888" }}>
            {user.department_name} - {user.position_kh}
          </div>
        </div>
      </div>
    </Select.Option>
  ))}
</Select>

</Form.Item>

         
          
          {/* You would add more Form.Items here for fullname, position, etc. */}
          
          {/* Button container at the bottom as requested */}
          <Form.Item style={{ textAlign: 'right', marginTop: 24 }}>
            <Button style={{ marginRight: 8 }} onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit"   loading={btnLoading}    >
              {editingUser ? 'Save Changes' : 'Add User'}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default UserWebSystem;